import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { FormControl } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import ManageCategoryItem from "../ManageCategoryItem/ManageCategoryItem";
import Link from "../../Link/Link";

import messages from "../../../locale/messages";
import debounce from "../../../helpers/debounce";

import noResult from '../../../../public/Icons/noResult.svg'

import bt from '../../../components/commonStyle.css';
import s from './ManageCategoryList.css';

const ManageCategoryList = ({ userCategoryDetails, categoryDetails, profileId, firstName, intl: { formatMessage } }) => {

    const [searchList, setSearchList] = useState('')

    const handleKeywordSearch = useCallback(debounce((searchValue) => {
        let variables = {
            searchList: searchValue
        }
        setSearchList(searchValue)
        if (categoryDetails?.refetch) {
            categoryDetails?.refetch(variables)
        }
    }), [categoryDetails?.refetch])


    let providerName = firstName.charAt(0).toUpperCase() + firstName.slice(1)


    return (
        <>
            <div className='addPageHeadingFlexContainer siteAdminPrimaryHeading'>
                <div>{formatMessage(messages.edit)} {providerName} {formatMessage(messages.services)} </div>
                <Link to={"/siteadmin/partners"} className={cx(bt.btnSecondary, s.displayInlineBlock)}>{formatMessage(messages.goBack)}</Link>
            </div>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
                <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
            </div>
            {categoryDetails?.getCategorySearch?.results?.length > 0 &&
                <div className={s.manageServiceCardContainer}>
                    {categoryDetails?.getCategorySearch?.results?.map((item) => {
                        const isSelected = userCategoryDetails?.getUserCategory?.some(
                            (selectedCategory) => selectedCategory.mainCategoryId === item.id
                        );

                        return (
                            <Link to={`/siteadmin/partners/sub-category/${profileId}/${item.id}`} key={item.id} className={s.manageServiceCard}>
                                <ManageCategoryItem
                                    CategoryId={item.id}
                                    categoryName={item.name}
                                    logoImage={item.logoImage}
                                    isSelected={isSelected}
                                />
                            </Link>
                        )
                    })}
                </div>}
            {categoryDetails?.getCategorySearch?.results?.length == 0 &&
                <div className={s.manageServiceCardNoResultContainer}>
                    <div className={s.manageServiceCardNoResultImgBox}>
                        <img src={noResult} alt="CategoryNoListImgContainer" className={s.manageServiceCardNoResultImg} />
                    </div>
                    <div className={s.manageServiceCardNoResultText}><FormattedMessage {...messages.noResult} /></div>
                </div>}
        </>
    )
}

ManageCategoryList.propTypes = {
    categoryDetails: PropTypes.object,
}

export default injectIntl(withStyles(bt, s)(ManageCategoryList));
